import React, { useContext } from 'react';
import { Alert, Box } from '@cloudscape-design/components';
import { AccountContext } from 'src/context/accountContext';

/**
 * Maps API permission levels to user-friendly display text
 */
const permissionLevelDisplayNames = {
  READ_ONLY: 'read-only',
  READ_AND_LIMITED_ACTION: 'limited access',
  ADMINISTER: 'administrator',
};

/**
 * Displays a banner with information about the user's permission level for the current account.
 * Shows a warning for read-only access and an info message for limited access.
 * Does not render anything for administrator access or when no account is selected.
 */
const PermissionBanner = () => {
  const { selectedAccount } = useContext(AccountContext);

  if (!selectedAccount || selectedAccount.permissionLevel === 'ADMINISTER') {
    return null;
  }

  const isReadOnly = selectedAccount.permissionLevel === 'READ_ONLY';
  const displayName = selectedAccount.permissionLevel
    ? permissionLevelDisplayNames[selectedAccount.permissionLevel] || 'limited'
    : '';

  return (
    <Box margin={{ top: 'm', bottom: 'm' }}>
      <Alert
        type={isReadOnly ? 'warning' : 'info'}
        header={`You have ${displayName} permissions for this account`}
      >
        {isReadOnly
          ? 'You can view resources but cannot make any changes.'
          : 'Some features may be restricted based on your access level.'}
      </Alert>
    </Box>
  );
};

export default PermissionBanner;
